import React, {useState, useContext} from 'react';
import { withPrefix } from "gatsby";

// Hooks //
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import useMetaSearch from "../../../shared/hooks/useMetaSearch";

// Utils //
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

// Context //
import GlobalContext from "../../../contexts/globalContext";

// Styles //
import "./searchContent.scss";

interface SearchContentInterface {
    type: "bibliotecaComunidadesEmpleo" | "bibliotecaPersonasEmpleo" |  "bibliotecaEmpresasEmpleo" | "foroEmpleo" | "encontrarTalento";
    compact?: boolean;
    onSelect?: Function;
    scrollIntoQuestion?: Function;
    defaultPlaceholder?: string;
    page?: "mainPage" | "resultPage"; 
    getSearchWord?: (str: string) => void;
    labelButton?: string;
    cleanButton?: boolean;
}

const SearchContent = (props: SearchContentInterface) => {
    const {
        type,
        onSelect,
        scrollIntoQuestion,
        page,
        labelButton,
        cleanButton
    } = props;
    const [searchWord, setSearchWord] = useState("");
    const {filterSearch, doSearch} = useMetaSearch(type);
    const { isBrowser, document } = useBrowserMode();
    const { setSearchWordContent} = useContext(GlobalContext);

    const renderFormattedText = (text, word) => {
        const comparingText = text !== null && text.toLowerCase().indexOf(word.toLowerCase());
        const formattedText =
            text !== null && comparingText !== -1 ? (
                <React.Fragment>
                    {text.slice(0, comparingText)}
                    <span>
                        {text.slice(comparingText, comparingText + word.length)}
                    </span>
                    {text.slice(comparingText + word.length)}
                </React.Fragment>
            ) : (
                text
            );
        return formattedText;
    };

    const handleOnClick = () =>{
        if (page === "mainPage") {
            isBrowser &&
            searchWord.trim().length > 2 &&
            window.location.assign(
               `${window.location.pathname}resultados-busqueda/?search=${searchWord}`
            );
            isBrowser &&
            searchWord.trim().length > 2 && setSearchWordContent && setSearchWordContent(searchWord);
        }
         if (page === "resultPage" && isBrowser) {
            const trimmedSearchWord = searchWord.trim();
      
            const targetUrl =
               trimmedSearchWord.length === 0
                  ? window.location.pathname
                  : trimmedSearchWord.length > 2
                  ? `${window.location.pathname}?search=${encodeURIComponent(trimmedSearchWord)}`
                  : null;
      
            if (targetUrl && window.location.href !== targetUrl) {
               window.location.assign(targetUrl);
            }
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && type === "bibliotecaComunidadesEmpleo") {
            isBrowser &&
            searchWord.trim().length > 2 && document.body.classList.add("search-result");
            isBrowser &&
            searchWord.trim().length > 2 && setSearchWordContent && setSearchWordContent(searchWord);
            isBrowser &&
            searchWord.trim().length > 2 && setSearchWord("");
            doSearch("");
        }
        if (e.key === "Enter" && page === "mainPage") {
            isBrowser &&
            searchWord.trim().length > 2 &&
            window.location.assign(
               `${window.location.pathname}resultados-busqueda/?search=${searchWord}`
            );
            isBrowser &&
            searchWord.trim().length > 2 && setSearchWordContent && setSearchWordContent(searchWord);
        }
        if (e.key === "Enter" && page === "resultPage") {
            isBrowser &&
            searchWord.trim().length > 2 &&
            window.location.assign(
               `${window.location.pathname}?search=${searchWord}`
            );
        }
    };

    const pathName = isBrowser ? window.location.pathname: ''
    
    return (
        <div className="m-search-content">
            <div className="m-search-content__container">
                <div className={`m-search-content__input ${labelButton ? "label" : ""}`}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22.536"
                        height="22.536"
                        viewBox="0 0 22.536 22.536"
                        className="m-search-content__input__icon"
                    >
                        <path
                            id="Trazado_38818"
                            data-name="Trazado 38818"
                            d="M22.223-3.053,16.667-8.684a8.882,8.882,0,0,0,1.99-4.28,9.335,9.335,0,0,0-.375-4.693A9.287,9.287,0,0,0,15.653-21.6a9.181,9.181,0,0,0-4.167-2.177,9.621,9.621,0,0,0-4.693.113A9.008,9.008,0,0,0,2.7-21.3,9.008,9.008,0,0,0,.337-17.206a9.621,9.621,0,0,0-.113,4.693A9.181,9.181,0,0,0,2.4-8.347,9.287,9.287,0,0,0,6.344-5.719a9.335,9.335,0,0,0,4.693.375,8.882,8.882,0,0,0,4.28-1.99l5.631,5.556a.751.751,0,0,0,.638.3.915.915,0,0,0,.676-.263.915.915,0,0,0,.263-.676A.751.751,0,0,0,22.223-3.053ZM9.384-7.108A7.286,7.286,0,0,1,5.63-8.121a7.571,7.571,0,0,1-2.74-2.74,7.286,7.286,0,0,1-1.014-3.754A7.286,7.286,0,0,1,2.89-18.37a7.571,7.571,0,0,1,2.74-2.74,7.286,7.286,0,0,1,3.754-1.014,7.286,7.286,0,0,1,3.754,1.014,7.571,7.571,0,0,1,2.74,2.74,7.286,7.286,0,0,1,1.014,3.754,7.286,7.286,0,0,1-1.014,3.754,7.571,7.571,0,0,1-2.74,2.74A7.286,7.286,0,0,1,9.384-7.108Z"
                            transform="translate(0.013 24.013)"
                            fill="#6f7287"
                        />
                    </svg>
                    <input
                        value={searchWord}
                        type="text"
                        placeholder="Buscar"
                        name="searchInput"
                        id="searchInput"
                        onChange={(text) => {
                            doSearch(text.currentTarget.value);
                            setSearchWord(text.currentTarget.value);
                        }}
                        onKeyDown={handleKeyDown}
                    />
                    {searchWord != "" && (
                        <span className="icon-close close-button" onClick={() => setSearchWord("")}></span>
                    )}
                    <button className={
                        pathName.split('/')[3] == "encontrar_talento" ? 
                            `gtm_${pathName.split('/')[3]}_boton_buscar_cabecera` : 
                            `gtm_buscar_${pathName.split('/')[2]}queconectan`} 
                        onClick={handleOnClick}>
                        {labelButton ? (
                            <>
                                {labelButton}
                            </>
                        ) : (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19.596"
                                height="16.949"
                                viewBox="0 0 19.596 16.949"
                            >
                                <path
                                    id="Trazado_38810"
                                    data-name="Trazado 38810"
                                    d="M18.935-26.55a1.126,1.126,0,0,0-.45.957,1.126,1.126,0,0,0,.45.957l4.617,4.617L8.911-19.9a1.3,1.3,0,0,0-.957.394,1.3,1.3,0,0,0-.394.957,1.5,1.5,0,0,0,.394,1.014,1.227,1.227,0,0,0,.957.45L23.552-17.2l-4.617,4.73a1.39,1.39,0,0,0-.394,1.351,1.282,1.282,0,0,0,1.014,1.014,1.275,1.275,0,0,0,1.408-.45l5.068-4.955a4.355,4.355,0,0,0,1.126-3.041,4.355,4.355,0,0,0-1.126-3.041L20.962-26.55A1.4,1.4,0,0,0,19.948-27,1.4,1.4,0,0,0,18.935-26.55Z"
                                    transform="translate(-7.56 27)"
                                    fill="#fff"
                                />
                            </svg>
                        )}
                    </button>
                </div>
                <div className={`m-search-content__results ${
                    searchWord.trim().length > 2
                        ? "m-search-content__results--active"
                        : ""
                }`}>
                    <ul>
                        {filterSearch && filterSearch.map((result, index) => (
                                <li
                                    key={`result${index}`}
                                    onClick={() => {
                                        if (onSelect !== undefined &&scrollIntoQuestion !==undefined) {
                                            onSelect(result);
                                            doSearch("");
                                            setSearchWord("");
                                            scrollIntoQuestion(
                                                result.titulo
                                            );
                                        }
                                    }}
                                >
                                    <a
                                        href={type ? `${withPrefix(
                                                        result.slug
                                                    )}`
                                                : "#"
                                        }
                                        target="_self"
                                        rel="noreferrer"
                                        className={`gtmResultadosPredictivo${normalizeTwoWords(
                                            type ? result.titulo
                                                : result.tituloBanner
                                        )}${normalizeTwoWords(
                                            result.tipoContenido
                                        )}${normalizeTwoWords(
                                            result.categoria
                                        )}`}
                                    >
                                        <p
                                            className={`gtmResultadosPredictivo${normalizeTwoWords(
                                                type ? result.titulo
                                                     : result.tituloBanner
                                            )}${normalizeTwoWords(
                                                result.tipoContenido
                                            )}${normalizeTwoWords(
                                                result.categoria
                                            )}`}
                                        >
                                            <span
                                                className={`m-search-content__results__title 
                                gtmResultadosPredictivo${normalizeTwoWords(
                                    type ? result.titulo
                                         : result.tituloBanner
                                )}${normalizeTwoWords(
                                                    result.tipoContenido
                                                )}${normalizeTwoWords(
                                                    result.categoria
                                                )}`}
                                            >
                                                {renderFormattedText(
                                                    type
                                                        ? result.titulo
                                                        : result.tituloBanner,
                                                    searchWord
                                                )}
                                            </span>
                                            <br />
                                            <span
                                                className={`m-search-content__results__subtitle
                                gtmResultadosPredictivo${normalizeTwoWords(
                                    type ? result.titulo
                                         : result.tituloBanner
                                )}${normalizeTwoWords(
                                                    result.tipoContenido
                                                )}${normalizeTwoWords(
                                                    result.categoria
                                                )}
                            `}
                                            >
                                                {type &&
                                                    renderFormattedText(
                                                        result.tipoContenido,
                                                        searchWord
                                                    )}
                                                {type &&
                                                    ": "}
                                                {renderFormattedText(
                                                    result.categoria,
                                                    searchWord
                                                )}
                                            </span>
                                        </p>
                                    </a>
                                </li>
                            )
                        )}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default SearchContent
